import styled from 'styled-components';
import { Android16New, Apple16New } from 'ui/icons';
import { InputText } from 'ui/inputs';
import { FormField, HelpText } from 'ui/formField';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { colors, spacing } from 'ui/theme';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { getIsEditMode, InputTextWithBadge } from '../../common';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { PushContentDefinition } from '../../../graphql';

const MediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

const ReadOnlyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  padding-bottom: ${spacing.threeQuarter};
`;

export const DeepLinks = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const showOnlyIfDataExistsViaAPIorIfLinkIsBeingEdited = pushData.deeplink !== null;

  return (
    <>
      {showOnlyIfDataExistsViaAPIorIfLinkIsBeingEdited && (
        <FormField isHorizontalLayout labelText={SETTINGS_DISPLAY_CONTENT.deepLink.labelText}>
          {isEditModeVisible ? (
            <MediaContainer>
              <InputWrapper>
                <InputText
                  id="settings-deeplink-ios"
                  data-test="settings-deeplink-ios"
                  Prefix={
                    <Badge variant={BADGE_VARIANTS.INFO}>
                      <Apple16New color={colors.grey50} />
                    </Badge>
                  }
                  onChange={(ios) =>
                    setCurrentMediumField('deeplink', { ...pushData.deeplink, ios })
                  }
                  value={pushData.deeplink?.ios || ''}
                  placeholder={SETTINGS_DISPLAY_CONTENT.deepLink.placeholder}
                  width="100%"
                />
              </InputWrapper>
              <InputWrapper>
                <InputText
                  id="settings-deeplink-android"
                  data-test="settings-deeplink-android"
                  Prefix={
                    <Badge variant={BADGE_VARIANTS.INFO}>
                      <Android16New color={colors.grey50} />
                    </Badge>
                  }
                  onChange={(android) =>
                    setCurrentMediumField('deeplink', { ...pushData.deeplink, android })
                  }
                  value={pushData.deeplink?.android || ''}
                  placeholder={SETTINGS_DISPLAY_CONTENT.deepLink.placeholder}
                  width="100%"
                />
                <HelpText>{SETTINGS_DISPLAY_CONTENT.deepLink.helpText}</HelpText>
              </InputWrapper>
            </MediaContainer>
          ) : (
            <ReadOnlyContainer>
              <InputTextWithBadge
                dataTest={'deeplink-ios'}
                badgeContent={<Apple16New color={colors.grey50} />}
                link={pushData.deeplink?.ios || SETTINGS_DISPLAY_CONTENT.unsetText}
              />
              <InputTextWithBadge
                dataTest={'deeplink-android'}
                badgeContent={<Android16New color={colors.grey50} />}
                link={pushData.deeplink?.android || SETTINGS_DISPLAY_CONTENT.unsetText}
              />
            </ReadOnlyContainer>
          )}
        </FormField>
      )}
    </>
  );
};
